var TextArea_Util = {
  autoGrow: function (element) {
    element.style.height = "5px";
    element.style.height = (element.scrollHeight)+"px";
  },
};
